/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from "react";
import { BreadcrumbComponent } from "../../../../common/components";
import CreateLeadCaptureFormPreview from "./create-lead-capture-form-preview";
import { getResponsePreviewBreadcrumbLink } from "./create-lead-capture-form-helper";
import { getSurveySubmittedFormsByID } from "../../../../api/surveys";
import "./create-lead-capture-form.scss";

const ViewSurveysForms = (props: any) => {
  const {
    setAlertOpen,
    setAlertMessage,
    setAlertType,
    setLoading,
    setViewOpen,
    setIsShowCreateLeadSection,
    selectedLeadCaptureFormId,
    createLeadCaptureInitialValues, 
    setCreateLeadCaptureInitialValues,
    setResponseViewOpen
  } = props;

  const initialColumns={
    main: {
      id: "main",
      list: [
        { title: "primaryPhoneNumber", id: 5, isRequired: false, isShowRequired: true, value: createLeadCaptureInitialValues?.primary_phone_number || "" },
        { title: "age", id: 6, isRequired: false, isShowRequired: true, value: createLeadCaptureInitialValues?.age || "" },
        { title: "industry", id: 7, isRequired: false, isShowRequired: true , value: createLeadCaptureInitialValues?.industry || "" },
        {
          title: "designation",
          id: 8,
          isRequired: false,
          isShowRequired: true,
          value: createLeadCaptureInitialValues?.designation || "",
        },
        {
          title: "interactionRate",
          id: 9,
          isRequired: false,
          isShowRequired: true,
          value: createLeadCaptureInitialValues?.overall_interaction_rating || "",
        },{
          title: "againIn",
          id: 10,
          isRequired: false,
          isShowRequired: true,
          value: createLeadCaptureInitialValues?.future_work_likelihood_rating || "",
        },{
          title: "customerSupport",
          id: 11,
          isRequired: false,
          isShowRequired: true,
          value: createLeadCaptureInitialValues?.customer_support_satisfaction_level || "",
        },{
          title: "product",
          id: 12,
          isRequired: false,
          isShowRequired: true,
          value: createLeadCaptureInitialValues?.product || "",
        },{
          title: "purchasedFor",
          id: 13,
          isRequired: false,
          isShowRequired: true,
          value: createLeadCaptureInitialValues?.purchased_for || "",
        },
        {
          title: "address",
          id: 14,
          isRequired: false,
          isShowRequired: true,
          value: createLeadCaptureInitialValues?.address || {},
        }],
    },
    sub: {
      id: "sub",
      list: [
        {
          title: "firstName",
          id: 1,
          isRequired: true,
          isShowRequired: false,
          showClose: true,
          value: createLeadCaptureInitialValues?.first_name || "",
        },
        {
          title: "lastName",
          id: 3,
          isRequired: true,
          isShowRequired: false,
          showClose: true,
          value: createLeadCaptureInitialValues?.last_name || "",
        },
        {
          title: "email",
          id: 3,
          isRequired: true,
          isShowRequired: false,
          showClose: true,
          value: createLeadCaptureInitialValues?.primary_email_address || "",
        },
      ],
    },
  }
  const [columns, setColumns] = useState<any>(initialColumns);

  
  const [formName, setFormName] = useState<any>("");
  const [subject, setSubject] = useState<any>("");
  const [type, setType] = useState<any>("");
  const [createLeadCaptureId, setCreateLeadCaptureId] = useState(null);
  const [surveySubmittedFormsValues, setSurveySubmittedFormsValues] = useState<any>(null);
  const [breadcrumbLink, setBreadcrumbLink] = useState<any>([]);

const getFullName = (item: any) => {
        if (!item) return "-";
        if (!item.first_name && !item.last_name) return "-";
        const firstName = item.first_name?.trim();
        const lastName = item.last_name?.trim()
        const fullName =
          firstName && lastName
            ? `${firstName} ${lastName}`
            : firstName || lastName || "-";

        const leadName = fullName;
        return leadName;
}

const getViewSurvey = async () => {
    setLoading(true);
    try {
      const response = await getSurveySubmittedFormsByID(selectedLeadCaptureFormId);
      setSurveySubmittedFormsValues(response.data.data);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(error?.response?.data?.message || "Failed to fetch survey data");
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
}
  useEffect(() => {
    if (surveySubmittedFormsValues) {
      setFormName(surveySubmittedFormsValues?.form_title || "");
      setSubject(surveySubmittedFormsValues?.form_email_subject || "");
      setType(surveySubmittedFormsValues?.form_email_body || "");
      setCreateLeadCaptureId(surveySubmittedFormsValues?.id);
      setColumns({
        ...columns,
        main: {
          ...columns.main,
          list: initialColumns?.main?.list?.filter((data: any) => {
            const checkForm = surveySubmittedFormsValues?.fields.find(
              (dataInitialValues: any) => {
                return dataInitialValues?.fieldName === data?.title;
              },
            );
            return checkForm ? false : true;
          }),
        },
        sub: {
          ...columns.sub,
          list: surveySubmittedFormsValues?.fields.map((data: any) => {    
            const checkFormMain = initialColumns?.main?.list?.find((dataInitialValues: any) => data?.fieldName === dataInitialValues?.title);
            const checkFormSub = initialColumns?.sub?.list?.find((dataInitialValues: any) => data?.fieldName === dataInitialValues?.title);
            return {
              ...data,
              isRequired: data?.required,
              title: data?.fieldName,
              value: checkFormMain?.value || checkFormSub?.value || "",
              id: data?.sequence,
              isShowRequired:
                (data?.fieldName !== "firstName" &&
                data?.fieldName !== "lastName" &&
                data?.fieldName !== "email")
                  ? true
                  : false,
              showClose:
                (data?.fieldName === "firstName" ||
                data?.fieldName === "lastName" ||
                data?.fieldName === "email")
                  ? true
                  :  false,
            };
          }),
        },
      });
    }
  }, [surveySubmittedFormsValues]);

  useEffect(() => {
    getViewSurvey();
    setBreadcrumbLink(getResponsePreviewBreadcrumbLink(
      setResponseViewOpen, 
      setViewOpen, 
      getFullName(createLeadCaptureInitialValues)
    ));
  }, []);

  const handleClosePreview = async () => {
    setIsShowCreateLeadSection(false);
    setViewOpen(false);
    setColumns(initialColumns);
    setFormName("");
    setCreateLeadCaptureInitialValues(null);
  };

  return (
    <>
      <div className="lead-capture-wrapper">
          <BreadcrumbComponent
            breadcrumbLink={breadcrumbLink}
            showBackArrow={true}
            handleBackArrowClick={() => {
             setResponseViewOpen(false);
            }}
          />
          <div>
            <CreateLeadCaptureFormPreview
              columns={columns}
              setColumns={setColumns}
              formName={formName}
              setFormName={setFormName}
              initialColumns={initialColumns}
              subject={subject}
              setSubject={setSubject}
              type={type}
              setType={setType}
              createLeadCaptureId={createLeadCaptureId}
              isViewMode={true}
              isResponseViewMode={true}
              handleClosePreview ={handleClosePreview}
            />
          </div>
      </div>
    </>
  );
};

export default ViewSurveysForms;
